import React from "react";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
import Footer from "./components/Footer";
import Header from "./components/Header";
import AccountPage from "./pages/account";
import AdminPage from "./pages/admin";
import CourseListPage from "./pages/courselist";
import ForgotPage from "./pages/forgot";
import LoginPage from "./pages/login";
import ResetPage from "./pages/reset";
import ScrollToTop from "./ScrollToTop";
import QueryLoading from "./components/animations/QueryLoading";
import PurchasePage from "./pages/purchase";

const User = ({ userData, userLoading, refetchUser }) => {
  return (
    <Router>
      <ScrollToTop>
        <Header
          userLoading={userLoading}
          userData={userData}
          refetchUser={refetchUser}
        />

        <Switch>
          <Route
            path="/login"
            render={(props) => (
              <LoginPage
                userLoading={userLoading}
                userData={userData}
                refetchUser={refetchUser}
                {...props}
              />
            )}
          />

          <Route
            path="/purchase"
            render={(props) => (
              <PurchasePage
                userLoading={userLoading}
                userData={userData}
                refetchUser={refetchUser}
                {...props}
              />
            )}
          />

          {/* User must be logged in to access these routes */}
          {!userLoading ? (
            !userData ? (
              <Redirect to="/login" />
            ) : (
              <Switch>
                <Route path="/forgot">
                  <ForgotPage />
                </Route>
                <Route path="/reset">
                  <ResetPage refetchUser={refetchUser} />
                </Route>

                <Route path="/account">
                  <AccountPage
                    userLoading={userLoading}
                    userData={userData}
                    refetchUser={refetchUser}
                  />
                </Route>
                <Route path="/admin">
                  <AdminPage
                    userLoading={userLoading}
                    userData={userData}
                    refetchUser={refetchUser}
                  />
                </Route>
                <Route
                  render={(props) => (
                    <CourseListPage
                      userLoading={userLoading}
                      userData={userData}
                      refetchUser={refetchUser}
                      {...props}
                    />
                  )}
                />
              </Switch>
            )
          ) : (
            <QueryLoading />
          )}
        </Switch>
        <Footer />
      </ScrollToTop>
    </Router>
  );
};

export default User;
